import {
  TELEGRAM_LINK,
  TELEGRAM_LINK_GLOBAL,
  VK_LINK_GLOBAL,
} from '@/_constants/routes';
import {
  TelegramFillTypographyIcon,
  VkFillTypographyIcon,
} from '@dpa/react-typography-icons';
import React from 'react';

type TFooterButton = {
  id: string;
  icon: React.ReactNode;
  link: string;
  text: string;
};

export const FOOTER_BUTTONS: Array<TFooterButton> = [
  {
    id: 'telegram',
    icon: <TelegramFillTypographyIcon typography="symbol-sm-primary" />,
    link: TELEGRAM_LINK,
    text: 'WB Партнеры',
  },
  {
    id: 'vk',
    icon: <VkFillTypographyIcon typography="symbol-sm-primary" />,
    link: VK_LINK_GLOBAL,
    text: 'WB Партнеры',
  },
  {
    id: 'telegram-global',
    icon: <TelegramFillTypographyIcon typography="symbol-sm-primary" />,
    link: TELEGRAM_LINK_GLOBAL,
    text: 'WB Global',
  },
];
